import { XUIIcon } from '@xero/xui/react/icon';
import location from '@xero/xui-icon/icons/location';

export default {
    BUTTONS: {
        CONNECT_APP: 'Buy custom connection',
    },
    DISPLAY_NAME: 'Custom Connection',
    ACCESS_PAGE: {
        APP_STORE_BILLING_BLURB: (
            <div data-testid='app-store-blurb'>
                <div>
                    Get premium access to Xero's API, enabling you or your developer to create a more secure, seamless
                    and efficient integration for your business.
                </div>
                <div className='xui-margin-top'>
                    <div>
                        <XUIIcon icon={location} color='black-faint' className='xui-margin-right' />
                        Available for Xero organisations in Australia, New Zealand and the United Kingdom.
                    </div>
                </div>
            </div>
        ),
        APP_STORE_BILLING_BLURB_WITH_US: (
            <div data-testid='app-store-blurb-with-us'>
                <div>
                    Get premium access to Xero's API, enabling you or your developer to create a more secure, seamless
                    and efficient integration for your business.
                </div>
                <div className='xui-margin-top'>
                    <div>
                        <XUIIcon icon={location} color='black-faint' className='xui-margin-right' />
                        Available for Xero organisations in Australia, New Zealand, United Kingdom and the United States
                        of America.
                    </div>
                </div>
            </div>
        ),
    },
    TAGS: [],
    ERROR: {},
    LEGAL_TEXT: (
        <div>
            When you buy a Custom Connection, you acknowledge that your use of that Custom Connection is subject to
            Xero’s{' '}
            <a href='https://www.xero.com/nz/about/legal/terms/?escape=true' target='_blank'>
                terms
            </a>
            ,{' '}
            <a href='https://www.xero.com/nz/about/privacy/?escape=true' target='_blank'>
                privacy notice
            </a>
            , and{' '}
            <a href='https://www.xero.com/nz/signup/offer-details/?escape=true' target='_blank'>
                offer details
            </a>
            .
        </div>
    ),
    PAID_PLAN: {
        FEATURES: [
            'Simple, fast connection: connect your subscription to third-party products using Xero’s API.',
            'Cost efficient: less time and complexity to customise your Xero experience.',
            'Highly secure: you can control the data you share with third-party providers.',
        ],
    },
};
